import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC, useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { pagesReset } from 'src/store/modules/pages';
import $ from 'jquery';

import {
  editTextReset,
  //
  editColor,
  editFontSize,
  editFontWeight,
  editPreFontSize,
  editText
} from 'src/store/modules/editText';
import {
  buttonsReset,
  editBtnColor,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnPreFontSize,
  editBtnText
} from 'src/store/modules/buttons';
import {
  imageReset,
  editBgImage,
  editCurrentIndex,
  editDeeplink
} from 'src/store/modules/imageUpload';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import setInitValue from 'src/utils/setInitValue';
import { changeText } from 'src/utils/changeText';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/RadiusModalSlideTracking';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import CountDown from 'src/components/CountDown';
import { getFontURL } from 'src/utils/getFontUrl';

// const TEXT_2_JUSTIFY = {
//   left: 'start',
//   center: 'center',
//   right: 'end'
// };

let today = new Date();
const initViewValues = {
  currentIndex: 0,
  bgImage: {
    multi_image: [
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp'
    ]
  },
  radius: { multi_image: 0 },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },

  text: {
    multi_title: [
      'Weekly Top Seller 1',
      'Weekly Top Seller 2',
      'Weekly Top Seller 3'
    ],
    countdown_title: 'Time Left',
    multi_countdown: [
      {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate() + 1,
        hour: 0,
        min: 0,
        sec: 0
      },
      {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate() + 1,
        hour: 0,
        min: 0,
        sec: 0
      },
      {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate() + 1,
        hour: 0,
        min: 0,
        sec: 0
      }
    ]
  },
  fontSize: { multi_title: 1.5, countdown_title: 0.875, multi_countdown: 1.75 },
  fontWeight: { multi_title: 500, countdown_title: 500, multi_countdown: 700 },
  color: {
    multi_title: '#ffffff',
    countdown_title: '#ffffff',
    multi_countdown: '#ffffff'
  },
  fontFamily: {
    multi_title: 'Montserrat',
    countdown_title: 'Montserrat',
    multi_countdown: 'Montserrat'
  },
  textAlign: {
    multi_title: 'left',
    countdown_title: 'right',
    multi_countdown: 'center'
  },

  btnText: { multi_button: ['Shop now 1', 'Shop now 2', 'Shop now 3'] },
  btnFontSize: { multi_button: 0.875 },
  btnFontWeight: { multi_button: 400 },
  btnColor: { multi_button: '#ffffff' },
  btnBgColorR: { multi_button: 0 },
  btnBgColorG: { multi_button: 0 },
  btnBgColorB: { multi_button: 0 },
  btnBgColorA: { multi_button: 0 },
  btnFontFamily: { multi_button: 'Montserrat' }
};

const RadiusModalSlide: FC = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const contentsSliderRef = useRef<any>(null);
  const [currentUser, setCurrentUser] = useState('');

  let clientName = useSelector((state: RootState) => state.client.userCompany);
  let templateWidth = useSelector(
    (state: RootState) => state.template.templateWidth
  );
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  // let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        setCurrentUser(current.attributes['custom:Company']);
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiCountDownFontURL = getFontURL(fontFamily?.multi_countdown);
  const countdownTitleFontURL = getFontURL(fontFamily?.countdown_title);
  const multiButtonFontURL = getFontURL(btnFontFamily?.multi_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiCountDownFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_countdown}`;
  // const countdownTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.countdown_title}`;
  // const multiButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_button}`;
  const closeImageUrl = 'https://i.ibb.co/xC9Gcwb/Frame-6.png';

  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url('${multiTitleFontURL}');
  }
  @font-face {
    font-family: 'multiCountdown';
    src: url('${multiCountDownFontURL}');
  }
  @font-face {
    font-family: 'countdownTitle';
    src: url('${countdownTitleFontURL}');
  }
  @font-face {
    font-family: 'multiButton';
    src: url('${multiButtonFontURL}');
  }

    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

    .root_view {
      width: 100%;
      height: 100%;

      position: relative;
      overflow: hidden;
      background: none;
    
      .background {
        width: 100%;
        height: 100%;

        position: absolute;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
      }
      .modal_wrapper {
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 1rem;
    
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    
        overflow: hidden;
        background-color: transparent;
      }

      .contents_wrapper {
        padding: 0 10%;
      }
      .contents_wrapper .title {
        width: 100%;
        height: 2.5rem;

        text-align: ${textAlign?.multi_title};
        color: ${color?.multi_title};
        font-size: ${fontSize?.multi_title}rem;
        font-weight: ${fontWeight?.multi_title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            fontFamily?.multi_title
          )
            ? fontFamily?.multi_title
            : 'multiTitle'
        };
      }

      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list {
        width: 100%;
        height: 12.5rem;
      }
      
      .slick_wrapper .slick-track div,
      .slick_wrapper .slick-track img {
        width: 15rem;
        height: 10rem;
        outline: none;
        border-radius: ${radius?.multi_image}px;
      }
      .slick_wrapper .slick-track img {
        object-flt: cover;
      }
      .slick_wrapper .slick-track {
        display: flex;
        margin-left: 10%;
      }
      .slick_wrapper .slick-track img {
        object-fit: cover;
      }

      .slick_wrapper .slick-slide {
        margin-right: 1rem;
      }
      .slick_wrapper .slick-list {
        margin-right: -1rem;
      }
      
      .timer_area {
        max-height: 1.5rem;
        margin-top: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #ffffff;
        font-size: 1.75rem;
        font-weight: 700;
        font-family: Montserrat;
      }

      .timer_area .countdown_text {
        max-height: 1.5rem;        
        display: flex;
        justify-content: start;
        align-items: center;
        color: #ffffff;
        font-size: 0.875rem;
        font-weight: 500;
        font-family: Montserrat;
      }
      .timer_area .timer {
        width: 10rem;
        height: 2rem;
        display: flex;
        
      }
      .timer_area li {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 3rem;
        height: 2rem;                
      }
      .timer_area .en {
        display: flex;
        align-items: center;
        margin-left: 0.3rem;        
        height: 2rem;        
      
      }
      .timer_area .finish_ment {        
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        white-space: pre-line;
        font-size: 1rem;
      }

      .bottom_wrapper {
        width: 100%;
        height: 2rem;
        padding: 0 10%;

        display: grid;
        grid-template-columns: 1fr 1fr;
      }
      .bottom_wrapper .bar {
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: start;
        align-items: center;
        text-align: left;
      }
      #bar_box {
        min-width: 7rem;
        max-width: 7rem;
        max-height: 0.125rem;
        min-height: 0.125rem;

        border-radius: 999px;
        background-color: #777777;
      }
      #bar_index {
        max-height: 0.125rem;
        min-height: 0.125rem;
        position: absolute;
        border-radius: 999px;
        background-color: #ffffff;
        transition: all ease 0.2s;
      }
      .bottom_wrapper .button {
        width: 100%;
        height: 100%;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        display: flex;
        justify-content: end;
        align-items: center;
        text-align: right;

        color: ${btnColor?.multi_button};
        font-size: ${btnFontSize?.multi_button}rem;
        font-weight: ${btnFontWeight?.multi_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.multi_button
          )
            ? btnFontFamily?.multi_button
            : 'multiButton'
        };
        background-color: rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
      }

      .close_btn {
        text-align: center;
      }
      .close_btn button {
        width: 1.5rem;
        height: 1.5rem;
        margin-top: 2rem;
        
        font-size: 0;
        border: none;

        background-image: url(${closeImageUrl});
        background-repeat: no-repeat;
        background-size: 1.5rem;
        background-position: center;
        background-color: transparent;
      }

      ${
        templateWidth > 767
          ? `
            .contents_wrapper {
              padding: 0 25%;
            }
            .contents_wrapper .title {
              height: 2.25rem;
              font-size: ${fontSize?.multi_title + 0.375}rem;
            }

            .slick_wrapper,
            .slick_wrapper .slick-slider,
            .slick_wrapper .slick-list {
              width: 100%;
              height: 17.5rem;
            }
            .slick_wrapper .slick-track div,
            .slick_wrapper .slick-track img {
              width: 24rem;
              height: 15rem;
            }
            .slick_wrapper .slick-track {
              margin-left: 25%;
            }
            .slick_wrapper .slick-slide {
              margin-right: 2rem;
            }
            .slick_wrapper .slick-list {
              margin-right: -2rem;
            }

            .slick_wrapper .countdown {
              max-height: 2rem;
              font-size: ${fontSize?.countdown_title + 0.375}rem;
            }
            .countdown_title {
              max-height: 2rem;
              margin-right: 1.5rem;
            }

            .bottom_wrapper {
              height: 2rem;
              padding: 0 25%;
            }
            #bar_box {
              min-width: 10rem;
              max-width: 10rem;
            }
            .bottom_wrapper .button {
              font-size: ${btnFontSize?.multi_button + 0.25}rem;
            }

            .close_btn button {
              margin-top: 4rem;
            }
          `
          : ``
      }
    }
  `;

  const settings = {
    arrows: false,
    infinite: false,
    dots: false,

    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    touchThreshold: 300
  };

  const contentsSettings = {
    arrows: false,
    infinite: false,
    fade: true,
    speed: 300,
    swipe: false
  };

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    // contentsSliderRef.current.slickGoTo(currentIndex);
    $('#bar_box').css('width', 7 + 'rem');
    $('#bar_index').css(
      'width',
      ((currentIndex + 1) / bgImage?.multi_image?.length) *
        (templateWidth > 767 ? 10 : 7) +
        'rem'
    );
  }, [bgImage?.multi_image, currentIndex]);

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    contentsSliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex]);

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          if (
            customValues?.bgImage &&
            customValues?.text &&
            customValues?.btnText
          ) {
            setInitValue(dispatch, customValues);
          } else {
            setValue(
              dispatch,
              customValues,
              { ...initViewValues, ...initTrackingValues },
              clientName
            );
          }
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(trackingReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="background"></div>
        <div className="modal_wrapper">
          <div className="contents_wrapper">
            <Slider {...contentsSettings} ref={contentsSliderRef}>
              {text?.multi_title?.map((data: any, idx: number) => {
                return (
                  <div key={idx} className="title">
                    {changeEnter(text?.multi_title?.[idx])}
                  </div>
                );
              })}
            </Slider>
          </div>
          <div className="slick_wrapper">
            <Slider
              {...settings}
              ref={sliderRef}
              afterChange={index => {
                dispatch(editCurrentIndex(index));
              }}
            >
              {text?.multi_title?.map((data: any, idx: number) => {
                return (
                  <div key={idx}>
                    <img
                      className="image"
                      src={bgImage?.multi_image?.[idx]}
                      alt="modal paging slide"
                    />

                    <div className="timer_area">
                      <p className="countdown_text">
                        {changeEnter(text?.countdown_title)}
                      </p>
                      <CountDown
                        key={idx}
                        time={text?.multi_countdown?.[idx]}
                      />
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
          <div>
            <div className="bottom_wrapper">
              <div className="bar">
                {bgImage?.multi_image?.length !== 1 && (
                  <>
                    <div id="bar_box"></div>
                    <div id="bar_index"></div>
                  </>
                )}
              </div>

              <div className="button">
                {btnText?.multi_button?.[currentIndex]}
              </div>
            </div>
            <div className="close_btn">
              <button>close</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const setValue = (
  dispatch: any,
  values: any,
  initViewValuess: any,
  clientName: any
) => {
  const MultiBackground = values?.imageName?.map((data: any) => {
    return `https://image.inappmessage.com/${clientName}/${data}`;
  });
  dispatch(
    editBgImage({
      multi_image: MultiBackground
    })
  );

  dispatch(editDeeplink({ multi_image: values?.newDeepLink }));

  const MultiCountdown = values?.newYear?.map((data: any, idx: number) => {
    return {
      year: data,
      month: values?.newMonth?.[idx],
      date: values?.newDate?.[idx],
      hour: values?.newHour?.[idx],
      min: values?.newMin?.[idx],
      sec: values?.newSec?.[idx]
    };
  });
  const newText = values?.newText?.map((data: any) => {
    return changeText(data);
  });
  dispatch(
    editText({
      multi_title: newText,
      countdown_title: values?.newTimerText,
      multi_countdown: MultiCountdown
    })
  );
  dispatch(
    editPreFontSize({
      ...initViewValuess?.fontSize,
      ...{
        multi_title: values?.newFontSize / 16
      }
    })
  );
  dispatch(
    editFontSize({
      ...initViewValuess?.fontSize,
      ...{
        multi_title: values?.newFontSize / 16
      }
    })
  );
  dispatch(
    editFontWeight({
      ...initViewValuess?.fontWeight,
      ...{
        multi_title: values?.newFontWeight,
        countdown_title: values?.newTimerFontWeight
      }
    })
  );
  dispatch(
    editColor({
      ...initViewValuess?.color,
      ...{
        multi_title: values?.newTextColor,
        countdown_title: values?.newTimerColor
      }
    })
  );
  // dispatch(editFontFamily(values?.fontFamily));
  // dispatch(editTextAlign(values?.textAlign));

  dispatch(
    editBtnText({
      multi_button: values?.newBtnText
    })
  );
  dispatch(
    editBtnPreFontSize({
      button: values?.newBtnFontSize / 16
    })
  );
  dispatch(
    editBtnFontSize({
      button: values?.newBtnFontSize / 16
    })
  );
  dispatch(
    editBtnFontWeight({
      button: values?.newBtnFontWeight
    })
  );
  dispatch(
    editBtnColor({
      multi_button: values?.newBtnTextColor
    })
  );
  // dispatch(
  //   editBtnBgColor(
  //     values?.btnBgColorR,
  //     values?.btnBgColorG,
  //     values?.btnBgColorB,
  //     values?.btnBgColorA
  //   )
  // );
  //     dispatch(editBtnFontFamily(values?.btnFontFamily));
  //     dispatch(editBtnTextAlign(values?.btnTextAlign));
};

export default RadiusModalSlide;
